import React from 'react';
import { ActionIconButton } from '../components/ui/ActionButton';

/** Shared utility action for upload, notifications and settings. */
export function MobileHeaderIconButton(props: React.ComponentProps<typeof ActionIconButton>) {
  return <ActionIconButton {...props} size="md" variant="neutral" className={`mobile-header__icon-btn ${props.className ?? ''}`} />;
}
